import { useState, useEffect } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "../../styles/Plans/countdown.css";

interface time {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
    days: number;
  };
}

const Countdown = (): JSX.Element => {
  const calculateTimeLeft = () => {
    let year = new Date().getFullYear();
    let difference = +new Date(`12/31/${year}`) - +new Date();

    let timeLeft: time["timeLeft"] = {
      hours: 0,
      minutes: 0,
      seconds: 0,
      days: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  const hours = timeLeft.hours;
  const minutes = timeLeft.minutes;
  const seconds = timeLeft.seconds;

  return (
    <div className="countdown container">
      <div>
        <CircularProgressbar
          value={hours}
          text={`${hours}`}
          maxValue={24}
          strokeWidth={7}
          styles={buildStyles({
            // Rotation of path and trail, in number of turns (0-1)
            rotation: 0.25,

            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: "butt",

            // Text size
            textSize: "2em",

            // How long animation takes to go from one percentage to another, in seconds
            pathTransitionDuration: 0.5,

            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: `rgba(255, 255, 255)`,
            textColor: "#FFFFFF",
            trailColor: "rgb(255 255 255 / 23%)",
            backgroundColor: "#3e98c7",
          })}
        />
        <p>Hrs</p>
      </div>
      <div>
        <CircularProgressbar
          value={minutes}
          text={`${minutes}`}
          maxValue={60}
          strokeWidth={7}
          styles={buildStyles({
            // Rotation of path and trail, in number of turns (0-1)
            rotation: 0.25,

            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: "butt",

            // Text size
            textSize: "2em",

            // How long animation takes to go from one percentage to another, in seconds
            pathTransitionDuration: 0.5,

            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: `rgba(255, 255, 255)`,
            textColor: "#FFFFFF",
            trailColor: "rgb(255 255 255 / 23%)",
            backgroundColor: "#3e98c7",
          })}
        />
        <p>Mins</p>
      </div>
      <div>
        <CircularProgressbar
          value={seconds}
          text={`${seconds}`}
          maxValue={60}
          strokeWidth={7}
          styles={buildStyles({
            // Rotation of path and trail, in number of turns (0-1)
            rotation: 0.25,

            // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
            strokeLinecap: "butt",

            // Text size
            textSize: "2em",

            // How long animation takes to go from one percentage to another, in seconds
            pathTransitionDuration: 0.5,

            // Can specify path transition in more detail, or remove it entirely
            // pathTransition: 'none',

            // Colors
            pathColor: `rgba(255, 255, 255)`,
            textColor: "#FFFFFF",
            trailColor: "rgb(255 255 255 / 23%)",
            backgroundColor: "#3e98c7",
          })}
        />
        <p>Secs</p>
      </div>
    </div>
  );
};

export default Countdown;
